import React from 'react'
import { View } from 'components/View'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { getIdHeaderBannerSelect } from 'modules/headerBanner/selectors/getId/index.js'
import {
  HEADER_BANNER_HEIGHT_DESKTOP,
  HEADER_BANNER_HEIGHT_SMALL_SCREEN,
  HEADER_BANNER_ID
} from 'modules/headerBanner/constants/index.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen/index.js'
import ComponentLoader from 'components/ComponentLoader/index.js'

/**
 * A mapping of modal id to Container.
 * @private
 * @type {Object}
 */
const HEADER_BANNER_ID_TO_COMPONENT_LOADER_FUNC = {
  [HEADER_BANNER_ID.NEW_CUSTOMER_DISCOUNT_TIMER]: () => import(/* webpackChunkName: "containers/NewCustomerHeaderBanner" */ 'containers/NewCustomerHeaderBanner')
}

/**
 * A mapping of modal id to Container.
 * @private
 * @type {Object}
 */
const HEADER_BANNER_ID_TO_EXPORT_NAME = {
  [HEADER_BANNER_ID.NEW_CUSTOMER_DISCOUNT_TIMER]: 'NewCustomerHeaderBanner'
}

export const HeaderBanner = () => {
  const id = useSelector(getIdHeaderBannerSelect)
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)

  if (!id) {
    return <></>
  }

  const funcPromise = HEADER_BANNER_ID_TO_COMPONENT_LOADER_FUNC[id]
  if (!funcPromise) {
    return <></>
  }

  const height = isSmallScreen
    ? HEADER_BANNER_HEIGHT_SMALL_SCREEN
    : HEADER_BANNER_HEIGHT_DESKTOP

  return (
    <View
      h={height}
      jc
      bgc='black'
    >
      <ComponentLoader
        loadComponent={funcPromise}
        shouldNotShowLoader
        componentExportName={HEADER_BANNER_ID_TO_EXPORT_NAME[id]}
      />
    </View>
  )
}
